import { Box, Stack, Typography, tokens } from '@cast/design-system';

type Props = {
  currentStep: number;
  totalSteps: number;
};

export const Stepper = ({ currentStep, totalSteps }: Props) => {
  return (
    <Stack direction="row" gap={8} alignItems="center">
      <Stack direction="row" gap={4}>
        {Array.from({ length: totalSteps }, (_, i) => (
          <Box
            key={i}
            sx={{
              width: tokens.primitives.space[600],
              height: tokens.primitives.space[100],
              borderRadius: '999px',
              backgroundColor:
                i < currentStep
                  ? tokens.theme.bg.selection.primary
                  : tokens.theme.bg.structural.surfaceRaised,
            }}
          />
        ))}
      </Stack>
      <Typography variant="P14R" color={tokens.theme.fg.structural.secondary}>
        {currentStep}/{totalSteps}
      </Typography>
    </Stack>
  );
};
